import React, { useState } from "react";
import Host from "../../Host/Host";

const Form = () => {
  const [formLoading, setFormLoading] = useState(false);
  const [form, setForm] = useState({
    pgname: "",
    childsName: "",
    childsAge: "",
    mobileNumber: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,

      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    console.log(form, "form");
    try {
      const res = await fetch(`${Host}/api/contact-leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: form }),
      });
      if (!res.ok) throw new Error("Failed to submit");
      alert("Message sent successfully!");
      // ✅ RESET FORM
      setForm({
        pgname: "",
        childsName: "",
        childsAge: "",
        mobileNumber: "",
        email: "",
        message: "",
      });
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <form className="admission-form">
      <input
        type="text"
        placeholder="Parent / Guardian Name *"
        name="pgname"
        value={form.pgname}
        onChange={handleChange}
        required
      />

      <input
        type="text"
        placeholder="Child’s Name *"
        name="childsName"
        value={form.childsName}
        onChange={handleChange}
        required
      />

      <input
        type="number"
        placeholder="Child’s Age *"
        name="childsAge"
        value={form.childsAge}
        onChange={handleChange}
        required
      />

      <input
        placeholder="Mobile Number *"
        type="number"
        name="mobileNumber"
        value={form.mobileNumber}
        onChange={handleChange}
        required
      />

      <input
        placeholder="Email Address *"
        type="email"
        name="email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <textarea
        placeholder="Message"
        rows="4"
        name="message"
        value={form.message}
        onChange={handleChange}
        required
      />
      <p className="required-note">Fields marked with * are mandatory.</p>

      <button
        className="btn-fill"
        type="submit"
        onClick={handleSubmit}
        disabled={formLoading}
      >
        {formLoading ? "Sending..." : "Submit Enquery"}
      </button>
    </form>
  );
};

export default Form;
